import { CareTeamState } from '../../store/types';
import { useMemo } from 'react';
import { useCareTeam } from './useCareTeam';

export const useCareTeamSelector = <T>(
  selector: (state: CareTeamState) => T,
) => {
  const [state] = useCareTeam();
  return useMemo(() => selector(state), [state, selector]);
};
